<a [href]="googleMapsUrl" target="_blank" [ngStyle]="{ 'max-width': maxWidth }">
  {{ googleDirection }}
</a>
